import { ReactComponent as AIChat } from "assets/icons/AIChat.svg"
import { ReactComponent as Arrow } from "assets/icons/Arrow.svg"
import { ReactComponent as ArrowChunky } from "assets/icons/ArrowChunky.svg"
import { ReactComponent as ArrowUp } from "assets/icons/ArrowUp.svg"
import { ReactComponent as Attachment } from "assets/icons/Attachment.svg"
import { ReactComponent as Bell } from "assets/icons/Bell.svg"
import { ReactComponent as BellOff } from "assets/icons/BellOff.svg"
import { ReactComponent as BusinessmanLight } from "assets/icons/BusinessmanLight.svg"
import { ReactComponent as CalendarAdded } from "assets/icons/CalendarAdded.svg"
import { ReactComponent as CalendarCancelled } from "assets/icons/CalendarCancelled.svg"
import { ReactComponent as CalendarLocation } from "assets/icons/CalendarLocation.svg"
import { ReactComponent as CalendarOther } from "assets/icons/CalendarOther.svg"
import { ReactComponent as CalendarTime } from "assets/icons/CalendarTime.svg"
import { ReactComponent as Checkmark } from "assets/icons/Checkmark.svg"
import { ReactComponent as CheckmarkCircle } from "assets/icons/CheckmarkCircle.svg"
import { ReactComponent as Chevron } from "assets/icons/Chevron.svg"
import { ReactComponent as ChevronLight } from "assets/icons/ChevronLight.svg"
import { ReactComponent as Clock } from "assets/icons/Clock.svg"
import { ReactComponent as ClockLight } from "assets/icons/ClockLight.svg"
import { ReactComponent as Close } from "assets/icons/Close.svg"
import { ReactComponent as Compose } from "assets/icons/Compose.svg"
import { ReactComponent as Devices } from "assets/icons/Devices.svg"
import { ReactComponent as Dots } from "assets/icons/Dots.svg"
import { ReactComponent as Download } from "assets/icons/Download.svg"
import { ReactComponent as Edit } from "assets/icons/Edit.svg"
import { ReactComponent as ExclamationMarkCircle } from "assets/icons/ExclamationMarkCircle.svg"
import { ReactComponent as Explore } from "assets/icons/Explore.svg"
import { ReactComponent as HelpCircle } from "assets/icons/HelpCircle.svg"
import { ReactComponent as Home } from "assets/icons/Home.svg"
import { ReactComponent as Info } from "assets/icons/Info.svg"
import { ReactComponent as InfoCircle } from "assets/icons/InfoCircle.svg"
import { ReactComponent as Language } from "assets/icons/Language.svg"
import { ReactComponent as Lightning } from "assets/icons/Lightning.svg"
import { ReactComponent as Like } from "assets/icons/Like.svg"
import { ReactComponent as List } from "assets/icons/List.svg"
import { ReactComponent as Lock } from "assets/icons/Lock.svg"
import { ReactComponent as Logout } from "assets/icons/Logout.svg"
// Aliased: a bare `Map` shadows the global.
import { ReactComponent as MapIcon } from "assets/icons/Map.svg"
import { ReactComponent as Medal } from "assets/icons/Medal.svg"
import { ReactComponent as MedalLight } from "assets/icons/MedalLight.svg"
import { ReactComponent as MeetingLight } from "assets/icons/MeetingLight.svg"
import { ReactComponent as Minus } from "assets/icons/Minus.svg"
import { ReactComponent as Newspaper } from "assets/icons/Newspaper.svg"
import { ReactComponent as Notification } from "assets/icons/Notification.svg"
import { ReactComponent as PeopleLight } from "assets/icons/PeopleLight.svg"
import { ReactComponent as PinLight } from "assets/icons/PinLight.svg"
import { ReactComponent as Play } from "assets/icons/Play.svg"
import { ReactComponent as Plus } from "assets/icons/Plus.svg"
import { ReactComponent as Refresh } from "assets/icons/Refresh.svg"
import { ReactComponent as Search } from "assets/icons/Search.svg"
import { ReactComponent as Send } from "assets/icons/Send.svg"
import { ReactComponent as Sparkle } from "assets/icons/Sparkle.svg"
import { ReactComponent as Sparkles } from "assets/icons/Sparkles.svg"
import { ReactComponent as Stack } from "assets/icons/Stack.svg"
import { ReactComponent as Star } from "assets/icons/Star.svg"
import { ReactComponent as DoubleArrow } from "assets/icons/TempDoubleArrow.svg"
import { ReactComponent as Users } from "assets/icons/Users.svg"

export const icons = {
  AIChat,
  Arrow,
  ArrowChunky,
  ArrowUp,
  Attachment,
  Bell,
  BellOff,
  CalendarAdded,
  CalendarCancelled,
  CalendarLocation,
  CalendarOther,
  CalendarTime,
  BusinessmanLight,
  Checkmark,
  CheckmarkCircle,
  Chevron,
  ChevronLight,
  Clock,
  ClockLight,
  Close,
  Compose,
  Devices,
  Dots,
  DoubleArrow,
  Download,
  Edit,
  ExclamationMarkCircle,
  Explore,
  HelpCircle,
  Home,
  Info,
  InfoCircle,
  Language,
  Lightning,
  Like,
  List,
  Lock,
  Logout,
  Map: MapIcon,
  Medal,
  MedalLight,
  MeetingLight,
  Minus,
  Newspaper,
  Notification,
  PeopleLight,
  PinLight,
  Play,
  Plus,
  Refresh,
  Search,
  Send,
  Sparkle,
  Sparkles,
  Stack,
  Star,
  Users,
}

export type IconType = keyof typeof icons
